/// <amd-module name="VSSUI/ExpandableTextField" />
export { ExpandableTextField } from "./Components/ExpandableTextField/ExpandableTextField";
export { IExpandableTextFieldProps } from "./Components/ExpandableTextField/ExpandableTextField.Props";
